import React, { useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CONTRACT, ALCOR_SWAP, ALCOR_CHART } from '../data';
import { CopyIcon, CheckIcon, ArrowIcon, ChartIcon } from './icons';
import pepe from '../../public/waxpepewar.webp';
import '../styles/hero.css';

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};
const item = {
  hidden: { opacity: 0, y: 26 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const Hero = () => {
  const [copied, setCopied] = useState(false);
  const { scrollY } = useScroll();
  const pepeY = useTransform(scrollY, [0, 600], [0, 120]);
  const glowY = useTransform(scrollY, [0, 600], [0, 60]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch { /* clipboard unavailable */ }
  };

  return (
    <section className="hero" id="top">
      <motion.div className="hero-copy" variants={container} initial="hidden" animate="show">
        <motion.span className="eyebrow" variants={item}>$KEK · community meme token on WAX</motion.span>

        <motion.h1 className="hero-title" variants={item}>
          a meme token on WAX<br />
          <span className="hero-title-accent">for entertainment only</span>
        </motion.h1>

        <motion.p className="hero-lead" variants={item}>
          $KEK is a community meme token on WAX. Transfers include a fee mechanic, but
          this is not an investment product and has no intrinsic value or expectation of
          financial return. Trade only if you accept the risk of loss.
        </motion.p>

        <motion.div className="hero-actions" variants={item}>
          <a className="btn btn-primary" href={ALCOR_SWAP} target="_blank" rel="noopener noreferrer">
            View on Alcor <ArrowIcon />
          </a>
        </motion.div>

        <motion.button className={`hero-ca ${copied ? 'is-copied' : ''}`} onClick={copy} variants={item}>
          <span className="hero-ca-label">contract</span>
          <span className="hero-ca-value">{CONTRACT}</span>
          <span className="hero-ca-icon">{copied ? <CheckIcon /> : <CopyIcon />}</span>
        </motion.button>
      </motion.div>

      <div className="hero-visual">
        <motion.div className="hero-blob" style={{ y: glowY }} aria-hidden="true" />
        <motion.img
          src={pepe}
          alt="Wax Pepe, the KEK mascot"
          className="hero-pepe"
          style={{ y: pepeY }}
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
        />
        <div className="hero-ring" aria-hidden="true" />
      </div>

      <a className="hero-scroll" href="#about" aria-label="Scroll down">
        <span /> scroll
      </a>
    </section>
  );
};

export default Hero;
